export default __webpack_public_path__ + "static/media/contact_bg.0ffc5651.mp4";